<template>
    <div class="uploader">
        <div class="text">
            <Heading :h="2" size="xxl">
                {{ content.mediaUploader }}
            </Heading>
            <p class="description">
                {{ content.mediaUploaderDescription }}
            </p>
        </div>
        <div class="gradient">
            <img class="uploadImage"
                src="/assets/img/landing/uploader.jpg"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Uploader',
        props: {
            content: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .uploader {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .gradient {
        position: relative;
        max-width: 64rem;
        width: 100%;
        height: 32rem;
        border-radius: 1rem;
        background: radial-gradient(110% 130% at 2% 0%, #4AFBD0 0%, rgba(0, 71, 255, 0) 100%), radial-gradient(150% 200% at 100% 100%, #FFC85E 0%, rgba(255, 0, 0, 0) 100%), rgba(0, 0, 0, 0.2);
    }

    .uploadImage {
        position: absolute;
        left: 50%;
        bottom: -2rem;
        transform: translateX(-50%);
        max-width: 40rem;
        width: 80%;
        border-radius: 2rem;
    }

    .h2, .description {
        text-align: center;
    }

    .description {
        font-size: 1.5rem;
        font-family: $font-secondary;
        text-align: center;
        margin: 0 0 4rem 0;
        color: var(--color-grey-600);
    }

    @media all and (max-width: 640px) {
        .uploadImage {
            width: 100%;
            transform: translateX(-60%);
        }
    }

    @media all and (max-width: 480px) {
        .gradient {
            height: 24rem;
        }
    }
</style>